import { useCallback, useEffect, useRef, useState } from 'react';
export const NARROW_THRESHOLD = 360;

// Tracks the inline width of an element via ResizeObserver.
// Returns a callback ref to attach to the element, its current width, and
// whether the element is narrower than NARROW_THRESHOLD.
export function useWidth() {
  const [width, setWidth] = useState(undefined);
  const observerRef = useRef(null);
  const measureRef = useCallback(node => {
    var _observerRef$current;
    (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.disconnect();
    observerRef.current = null;
    if (!node || typeof ResizeObserver === 'undefined') {
      return;
    }

    // Measure synchronously on mount so the first paint uses the real width.
    setWidth(node.getBoundingClientRect().width);
    const observer = new ResizeObserver(entries => {
      var _entry$contentBoxSize;
      const entry = entries[0];
      if (!entry) {
        return;
      }
      const px = (_entry$contentBoxSize = entry.contentBoxSize) !== null && _entry$contentBoxSize !== void 0 && _entry$contentBoxSize[0] ? entry.contentBoxSize[0].inlineSize : entry.contentRect.width;
      setWidth(px);
    });
    observer.observe(node);
    observerRef.current = observer;
  }, []);
  useEffect(() => () => {
    var _observerRef$current2;
    (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 || _observerRef$current2.disconnect();
  }, []);
  const isNarrow = width !== undefined && width < NARROW_THRESHOLD;
  return [measureRef, width, isNarrow];
}